import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from '@material-ui/core';
import RegularButton from '../../components/CustomButtons/Button';
import Snackbars from '../../components/Snackbar/Snackbar.js';
import { 
  deleteContractCondition,
  createNewContractCondition,
  editContractCondition
} from '../../redux/actions/contractsConditionsCatalog/contractsConditionsCatalogActions';
import { useForm } from '../../hooks/useForm';

const blue = '#0055aa';

export const FormContractConditionEdit = (props) => {
  const { handleClose, stations } = props;
  const { contractsArr } = useSelector(state => state.contractsCatalog);
  const {
    contractConditionSelected, employeeTypes, branchOffices, pieceworks,
    seasons, tabulators, customerTypes, futures, addMode, deleteMode,
  } = useSelector(state => state.contractsConditionsCatalog);
  const { stationsSelected } = useSelector((state) => state.search);
  const { token } = useSelector(state => state.login);
  const [snackBar, setSnackBar] = useState(false);
  const [filteredContracts, setFilteredContracts] = useState([]);
  const { inputValues, handleInputOnChange, handleNewValues } = useForm({
    costCenter: '',
    branchOffice: '',
    idContract: '',
    idStation: '',
    baseSale: '',
    season: '',
    tabulator: '',
    employeeType: '',
    piecework: '',
    typeSale: '',
    customerType: '',
    future: '',
    period: '',
    route: '',
    transfers: '',
    status: true,
  })
  const dispatch = useDispatch();
  const {
    costCenter, branchOffice, idContract, idStation, baseSale, season, tabulator, employeeType,
    piecework, typeSale, customerType, future, period, route, transfers, status,
  } = inputValues;

  const handleSubmit = async() => {
    if(deleteMode){
      dispatch(deleteContractCondition(contractConditionSelected.id, token));
      handleClose();
      return;
    } 
    const name = contractsArr.filter(contract => contract.id === idContract)[0]?.name;
    const newValues = {
      ...contractConditionSelected,
      name,
      costCenter,
      branchOffice,
      idContract,
      idStation,
      baseSale,
      season,
      tabulator,
      employeeType,
      piecework,
      typeSale,
      customerType,
      future,
      period,
      route,
      transfers,
      status: status? 1 : 0
    };

    if( costCenter.length > 0 && branchOffice.length > 0 && idContract.length > 0 && idStation.length > 0 && baseSale.length > 0 
      && season.length > 0 && tabulator.length > 0 && employeeType.length > 0 && piecework.length > 0 && typeSale.length > 0
      && customerType.length > 0 && future.length > 0 && period.length > 0 && route.length > 0 && transfers.length > 0
    ) {
      if(addMode){
        dispatch(createNewContractCondition(newValues, token));
        handleClose();
      } else {
        dispatch(editContractCondition(contractConditionSelected.id, newValues, token));
        handleClose();
      }
    } else {
      setSnackBar(true);
    }
  };

  useEffect(() => {
    if (stationsSelected?.id) {
      handleNewValues({
        idStation: stationsSelected.id
      });
    }
    if (contractConditionSelected) {
      handleNewValues({
        costCenter: contractConditionSelected.costCenter,
        branchOffice: contractConditionSelected.branchOffice,
        idContract: contractConditionSelected.idContract,
        idStation: contractConditionSelected.idStation,
        baseSale: contractConditionSelected.baseSale,
        season: contractConditionSelected.season,
        tabulator: contractConditionSelected.tabulator,
        employeeType: contractConditionSelected.employeeType,
        piecework: contractConditionSelected.piecework,
        typeSale: contractConditionSelected.typeSale,
        customerType: contractConditionSelected.customerType,
        future: contractConditionSelected.future,
        period: contractConditionSelected.period,
        route: contractConditionSelected.route,
        transfers: contractConditionSelected.transfers,
        status: contractConditionSelected.status
      });
    }
    // eslint-disable-next-line 
  }, [contractConditionSelected, stationsSelected]);
  
  useEffect(() => {
    setFilteredContracts(contractsArr.filter(contract => contract.idStation === idStation));
    // eslint-disable-next-line 
  }, [idStation]);

  return (
    <>
    <Typography component="h2">
      {
        addMode
          ? 'Agregar nueva condición de contrato'
          : deleteMode ? '¿Estás seguro de eliminar esta condición contrato?'
          : 'Modificar condición de contrato'
      } 
    </Typography>
    <FormControl fullWidth style={{ display: 'flex', gap: 10, marginTop: 20 }} onSubmit={handleSubmit}>
          <FormControl fullWidth  variant="outlined">
            <InputLabel  id="demo-simple-select-outlined-label">Planta *</InputLabel>
            <Select
              name="idStation"
              id="demo-simple-select-outlined"
              value={idStation}
              onChange={e => handleInputOnChange(e)}
              label="Planta *"
              disabled={deleteMode || (stationsSelected?.id && !contractConditionSelected?.idStation)}
            >
              <MenuItem value="">
                <em>Seleccione una planta</em>
              </MenuItem>
              {
                stations.map(station => <MenuItem key={station.value} value={station.value}>{station.label}</MenuItem>)
              }
            </Select>
          </FormControl>
          <FormControl fullWidth  variant="outlined">
            <InputLabel  id="demo-simple-select-outlined-label">Contrato *</InputLabel>
            <Select
              name="idContract"
              id="demo-simple-select-outlined"
              value={idContract}
              onChange={e => handleInputOnChange(e)}
              label="Contrato *"
              disabled={deleteMode}
            >
              <MenuItem value="">
                <em>Seleccione un contrato</em>
              </MenuItem>
              {
                filteredContracts.map(contract => <MenuItem key={contract.id} value={contract.id}>{contract.name}</MenuItem>)
              }
            </Select>
          </FormControl>
          <TextField type="text" label="Centro de costo *" name="costCenter" value={costCenter} disabled={deleteMode} onChange={handleInputOnChange} variant="outlined" />
          <FormControl fullWidth  variant="outlined">
            <InputLabel  id="demo-simple-select-outlined-label">Venta Base de cálculo *</InputLabel>
            <Select
              name="baseSale"
              id="demo-simple-select-outlined"
              value={baseSale}
              onChange={e => handleInputOnChange(e)}
              label="Venta Base de cálculo *"
              disabled={deleteMode}
            >
              <MenuItem value="">
                <em>Seleccione un cálculo</em>
              </MenuItem>
              <MenuItem value="1">DIARIA</MenuItem>
              <MenuItem value="2">PROMEDIO DIARIA SEMANAL</MenuItem>
              <MenuItem value="3">SEMANAL</MenuItem>
              <MenuItem value="4">MENSUAL</MenuItem>
            </Select>
          </FormControl>
          <FormControl fullWidth  variant="outlined">
            <InputLabel  id="demo-simple-select-outlined-label">Temporada *</InputLabel>
            <Select
              name="season"
              id="demo-simple-select-outlined"
              value={season}
              onChange={e => handleInputOnChange(e)}
              label="Temporada *"
              disabled={deleteMode}
            >
              <MenuItem value="">
                <em>Seleccione una temporada</em>
              </MenuItem>
              {
                seasons.map(season => <MenuItem key={season.value} value={season.value}>{season.label}</MenuItem>)
              }
            </Select>
          </FormControl>
          <FormControl fullWidth variant="outlined">
            <InputLabel id="demo-simple-select-outlined-label">Tabulador *</InputLabel>
            <Select
              name="tabulator"
              id="demo-simple-select-outlined"
              value={tabulator}
              onChange={e => handleInputOnChange(e)}
              label="Tabulador *"
              disabled={deleteMode}
            >
              <MenuItem value="">
                <em>Seleccione un tipo de tabulador</em>
              </MenuItem>
              {
                tabulators.map(tabulator => <MenuItem key={tabulator.value} value={tabulator.value}>{tabulator.label}</MenuItem>)
              }
            </Select>
          </FormControl>
        <FormControl fullWidth variant="outlined">
            <InputLabel id="demo-simple-select-outlined-label">Tipo Empleado *</InputLabel>
            <Select
              name="employeeType"
              id="demo-simple-select-outlined"
              value={employeeType}
              onChange={e => handleInputOnChange(e)}
              label="Tipo Empleado *"
              disabled={deleteMode}
            >
              <MenuItem value="">
                <em>Seleccione un tipo de empleado</em>
              </MenuItem>
              {
                employeeTypes.map(employeeType => <MenuItem key={employeeType.value} value={employeeType.value}>{employeeType.label}</MenuItem>)
              }
            </Select>
          </FormControl>
          <FormControl fullWidth variant="outlined">
            <InputLabel id="demo-simple-select-outlined-label">Operación de Destajo *</InputLabel>
            <Select
              name="piecework"
              id="demo-simple-select-outlined"
              value={piecework}
              onChange={e => handleInputOnChange(e)}
              label="Operación de Destajo *"
              disabled={deleteMode}
            >
              <MenuItem value="">
                <em>Seleccione un tipo de movimiento</em>
              </MenuItem>
              {
                pieceworks.map(piecework => <MenuItem key={piecework.value} value={piecework.value}>{piecework.label}</MenuItem>)
              }
            </Select>
          </FormControl>
          <FormControl fullWidth variant="outlined">
            <InputLabel  id="demo-simple-select-outlined-label">Tipo de venta *</InputLabel>
            <Select
              name="typeSale"
              id="demo-simple-select-outlined"
              value={typeSale}
              onChange={e => handleInputOnChange(e)}
              label="Tipo de venta *"
              disabled={deleteMode}
            >
              <MenuItem value="">
                <em>Seleccione un tipo de movimiento</em>
              </MenuItem>
              <MenuItem value="0">NO APLICA</MenuItem>
              <MenuItem value="1">CONTADO</MenuItem>
              <MenuItem value="2">CREDITO</MenuItem>
            </Select>
          </FormControl>
          <FormControl fullWidth variant="outlined">
            <InputLabel id="demo-simple-select-outlined-label">Tipo de Cliente *</InputLabel>
            <Select
              name="customerType"
              id="demo-simple-select-outlined"
              value={customerType}
              onChange={e => handleInputOnChange(e)}
              label="Tipo de Cliente *"
              disabled={deleteMode}
            >
              <MenuItem value="">
                <em>Seleccione un tipo de movimiento</em>
              </MenuItem>
              {
                customerTypes.map(customerType => <MenuItem key={customerType.value} value={customerType.value}>{customerType.label}</MenuItem>)
              }
            </Select>
          </FormControl>
          <FormControl fullWidth variant="outlined">
            <InputLabel id="demo-simple-select-outlined-label">Futuro *</InputLabel>
            <Select
              name="future"
              id="demo-simple-select-outlined"
              value={future}
              onChange={e => handleInputOnChange(e)}
              label="Futuro *"
              disabled={deleteMode}
            >
              <MenuItem value="">
                <em>Seleccione un tipo de movimiento</em>
              </MenuItem>
              {
                futures.map(future => <MenuItem key={future.value} value={future.value}>{future.label}</MenuItem>)
              }
            </Select>
          </FormControl>
          <FormControl fullWidth variant="outlined">
            <InputLabel id="demo-simple-select-outlined-label">Sucursal *</InputLabel>
            <Select
              name="branchOffice"
              id="demo-simple-select-outlined"
              value={branchOffice}
              onChange={e => handleInputOnChange(e)}
              label="Sucursal *"
              disabled={deleteMode}
            >
              <MenuItem value="">
                <em>Seleccione una sucursal</em>
              </MenuItem>
              {
                branchOffices.map(branchOffice => <MenuItem key={branchOffice.value} value={branchOffice.value}>{branchOffice.label}</MenuItem>)
              }
            </Select>
          </FormControl>
          <FormControl fullWidth variant="outlined">
            <InputLabel id="demo-simple-select-outlined-label">Periodo de cálculo *</InputLabel>
            <Select
              name="period"
              id="demo-simple-select-outlined"
              value={period}
              onChange={e => handleInputOnChange(e)}
              label="Periodo de cálculo *"
              disabled={deleteMode}
            >
              <MenuItem value="">
                <em>Seleccione un tipo de cálculo</em>
              </MenuItem>
              <MenuItem value="1">DIARIO</MenuItem>
              <MenuItem value="2">SEMANAL</MenuItem>
              <MenuItem value="3">MENSUAL</MenuItem>
            </Select>
          </FormControl>
          <FormControl fullWidth variant="outlined">
            <InputLabel id="demo-simple-select-outlined-label">Ruta *</InputLabel>
            <Select
              name="route"
              id="demo-simple-select-outlined"
              value={route}
              onChange={e => handleInputOnChange(e)}
              label="Ruta *"
              disabled={deleteMode}
            >
              <MenuItem value="">
                <em>Seleccione un tipo de ruta</em>
              </MenuItem>
              <MenuItem value="0">NO APLICA</MenuItem>
              <MenuItem value="1">LOCAL</MenuItem>
              <MenuItem value="2">FORANEA</MenuItem>
            </Select>
          </FormControl>
          <FormControl fullWidth variant="outlined">
            <InputLabel id="demo-simple-select-outlined-label">Traspasos/Mayoreo *</InputLabel>
            <Select
              name="transfers"
              id="demo-simple-select-outlined"
              value={transfers}
              onChange={e => handleInputOnChange(e)}
              label="Traspasos/Mayoreo *"
              disabled={deleteMode}
            >
              <MenuItem value="">
                <em>Seleccione un tipo de movimiento</em>
              </MenuItem>
              <MenuItem value="0">NO APLICA</MenuItem>
              <MenuItem value="1">TRASPASO</MenuItem>
              <MenuItem value="2">MAYOREO</MenuItem>
            </Select>
          </FormControl>
      <Box sx={{display: 'flex', justifyContent: 'space-between', marginTop: 30}}>
        <RegularButton variant="contained" color="danger" onClick={handleClose}>Cancelar</RegularButton>
        <RegularButton 
          variant="contained" 
          color="facebook"
          style={{backgroundColor: blue, color: 'white'}} 
          onClick={handleSubmit}

        >
          { 
            addMode 
              ? 'Agregar' 
              : deleteMode ? 'Eliminar' 
              : 'Guardar'
          }
        </RegularButton>
      </Box>
    </FormControl>
    <Snackbars
        place="tr"
        color='danger'
        message="Campos con * son requeridos"
        open={snackBar}
        closeNotification={() => setSnackBar(false)}
        close
      /> 
    </>
  );
};
